import { BehaviorSubject } from "rxjs"
import { PedidoType } from "src/types"

const pedido$: BehaviorSubject<PedidoType | null> = new BehaviorSubject<PedidoType | null>(null);
const pedidoCodigo$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

const pedidoRedirect$: BehaviorSubject<PedidoType | null> = new BehaviorSubject<PedidoType | null>(null);
const pedidoCodigoRedirect$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

class PedidoStoreClass {

    getPedidoSubject(): BehaviorSubject<PedidoType | null> {
        return pedido$;
    }

    getPedidoCodigoSubject(): BehaviorSubject<string | null> {
        return pedidoCodigo$;
    }

    getPedidoRedirectSubject(): BehaviorSubject<PedidoType | null> {
        return pedidoRedirect$;
    }

    getPedidoCodigoRedirectSubject(): BehaviorSubject<string | null> {
        return pedidoCodigoRedirect$;
    }

    setPedido(pedido: PedidoType | null) {
        pedido$.next(pedido)
    }

    getPedido(): PedidoType | null {
        return pedido$.getValue();
    }

    setPedidoCodigo(pedidoCodigo: string | null) {
        pedidoCodigo$.next(pedidoCodigo)
    }

    getPedidoCodigo(): string | null {
        return pedidoCodigo$.getValue();
    }

    setPedidoRedirect(pedido: PedidoType | null) {
        pedidoRedirect$.next(pedido)
    }

    getPedidoRedirect(): PedidoType | null {
        return pedidoRedirect$.getValue();
    }

    setPedidoCodigoRedirect(pedidoCodigo: string | null) {
        pedidoCodigoRedirect$.next(pedidoCodigo)
    }

    getPedidoCodigoRedirect(): string | null {
        return pedidoCodigoRedirect$.getValue();
    }

}

export const PedidoStore = new PedidoStoreClass()
export { PedidoStoreClass }